var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_11292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7249 12.5577L8.60825 10.466L8.63325 10.441C10.0833 8.82435 11.1166 6.96602 11.7249 4.99935H14.1666V3.33268H8.33325V1.66602H6.66658V3.33268H0.833252V4.99102H10.1416C9.58325 6.59935 8.69992 8.12435 7.49992 9.45768C6.72492 8.59935 6.08325 7.65768 5.57492 6.66602H3.90825C4.51659 8.02435 5.34992 9.30768 6.39158 10.466L2.14992 14.6493L3.33325 15.8327L7.49992 11.666L10.0916 14.2577L10.7249 12.5577ZM15.4166 8.33268H13.7499L9.99992 18.3327H11.6666L12.5999 15.8327H16.5583L17.4999 18.3327H19.1666L15.4166 8.33268ZM13.2333 14.166L14.5833 10.5577L15.9333 14.166H13.2333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_11292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageEng);
export default __webpack_public_path__ + "static/media/language-eng.e5024e06fe88a36eaba7cc54c88e9af3.svg";
export { ForwardRef as ReactComponent };